import { RoutePath } from './route-path'
//Admin Portal
import AdminLoginPage from "admin-portal/user/login";
import AdminOTPPage from "admin-portal/user/otp";
import AdminLogout from "admin-portal/user/logout";
import AdminForgetPasswordPage from "admin-portal/user/forget-password";
import AdminResetPasswordPage from "admin-portal/user/reset-password";

// dashboard
import AdminDashboard from "admin-portal/dashboard";

import AdminUserProfile from "admin-portal/user/profile";

//tenant
import TenantSearchPage from "admin-portal/tenant/tenant-search-page"
import TenantOnboardPage from "admin-portal/tenant/onboard/tenant-onboard-page"
import TenantEditPage from "admin-portal/tenant/onboard/tenant-edit-page"

//setups
import ServiceTypePage from "admin-portal/setup/service-type-page"
import ServicesPage from "admin-portal/setup/services-page"
import VehicleModelImportPage from "admin-portal/setup/vehicle-model-import-page"

//Subscriptions
import SubscriptionPage from "admin-portal/subscription/index"
import SubscriptionManagePage from "admin-portal/subscription/manage"


//Login
import Login from "pages/authentication/login";
import OTPScreen from "pages/authentication/otp";
import Logout from "pages/authentication/logout";

import Register from "pages/authentication/register";
import UserProfile from "pages/authentication/user-profile";
import Account from "pages/pages/account";

// dashboard
import Analytics from "pages/dashboards/analytics";
import Ecommerce from "pages/dashboards/ecommerce";
import Email from "pages/dashboards/email";
import HRDashboard from "pages/dashboards/hr";
import SocialMediaDashboard from "pages/dashboards/social-media";

// Chat
import Chat from "pages/chat";

// Email
import Mailbox from "pages/email";

// Calendar
import DefaultCalendar from "pages/calendar/default";
import MonthGrid from "pages/calendar/month-grid";
import MultiMonthStack from "pages/calendar/multi-month-stack";

// Ecommerce
import ListView from "pages/ecommerce/products/list-view";
import GridView from "pages/ecommerce/products/grid-view";
import Overview from "pages/ecommerce/products/overview";
import AddNew from "pages/ecommerce/products/add-new";
import ShoppingCart from "pages/ecommerce/shopping-cart";
import Checkout from "pages/ecommerce/checkout";
import Orders from "pages/ecommerce/orders";
import OrderOverview from "pages/ecommerce/order-overview";
import Sellers from "pages/ecommerce/sellers";

// HR Management
import EmployeeList from "pages/hr-management/employee-list";
import Holidays from "pages/hr-management/holidays";
import LeaveManageEmployee from "pages/hr-management/leave-manage/leave-manage-employee";
import AddLeaveEmployee from "pages/hr-management/leave-manage/add-leave-employee";
import LeaveManageHR from "pages/hr-management/leave-manage/leave-manage-employee";
import AddLeaveHR from "pages/hr-management/leave-manage/add-leave-hr";
import AttendanceHR from "pages/hr-management/attendance/attendance-hr";
import MainAttendance from "pages/hr-management/attendance/main-attendance";
import Departments from "pages/hr-management/departments";
import Estimates from "pages/hr-management/sales/estimates";
import Payments from "pages/hr-management/sales/payments";
import Expenses from "pages/hr-management/sales/expenses";
import EmployeeSalary from "pages/hr-management/payroll/employee-salary";
import Payslip from "pages/hr-management/payroll/payslip";
import CreatePayslip from "pages/hr-management/payroll/create-payslip";

// Notes
import Notes from "pages/notes";

// Social Media
import Friends from "pages/social-media/friends";
import Event from "pages/social-media/event";
import WatchVideo from "pages/social-media/watch-video";
import Marketplace from "pages/social-media/marketplace";

// Invoices
import InvoiceListView from "pages/invoices/list-view";
import InvoiceAddNew from "pages/invoices/add-new";
import InvoiceOverview from "pages/invoices/overview";

// Users
import UserListView from "pages/users/list-view";
import UserGridView from "pages/users/grid-view";

// Ui element
import UiAlert from "pages/components/ui-element/ui-alert";
import UiAvatar from "pages/components/ui-element/ui-avatar";
import UiButtons from "pages/components/ui-element/ui-buttons";
import UIDrawer from "pages/components/ui-element/drawer";
import UiModal from "pages/components/ui-element/modal";
import UiLabel from "pages/components/ui-element/ui-label";
import UiCards from "pages/components/ui-element/ui-cards";
import UiCollapse from "pages/components/ui-element/ui-collapse";
import UiCountdown from "pages/components/ui-element/ui-countdown";
import UiDropdown from "pages/components/ui-element/ui-dropdown";
import UiGallery from "pages/components/ui-element/ui-gallery";
import UiLists from "pages/components/ui-element/ui-lists";
import UiNotification from "pages/components/ui-element/ui-notification";
import UiSpinners from "pages/components/ui-element/ui-spinners";
import UITimeline from "pages/components/ui-element/ui-timeline";
import UiProgressBar from "pages/components/ui-element/ui-progressBar";
import UITooltip from "pages/components/ui-element/ui-tooltip";
import UiVideo from "pages/components/ui-element/ui-video";

// plugins
import PSimpleBar from "pages/components/plugins/simplebar";
import PLightBox from "pages/components/plugins/lightbox";
import SwiperSlider from "pages/components/plugins/swiper-slider";
import ScrollHint from "pages/components/plugins/scroll-hint";
import VideoPlayer from "pages/components/plugins/video-player";

// navbar
import NavBars from "pages/components/navigation/navbars";
import NavTabs from "pages/components/navigation/tabs";
import NavigationBreadcrumb from "pages/components/navigation/navigation-breadcrumb";
import Pagination from "pages/components/navigation/pagination";

// forms
import FormsBasic from "pages/components/forms/basic";
import FormValidation from "pages/components/forms/validation";
import InputMask from "pages/components/forms/input-mask";
import FormSelect from "pages/components/forms/select";
import CheckboxRadio from "pages/components/forms/checkbox-radio";
import FormSwitches from "pages/components/forms/switches";
import FormWizard from "pages/components/forms/wizard/form-wizard";
import FileUpload from "pages/components/forms/file-upload";
import FormDatePicker from "pages/components/forms/datepicker";
import FormTimePicker from "pages/components/forms/timepicker";
import FormColorPicker from "pages/components/forms/colorpicker";
import FormMultiSelect from "pages/components/forms/multi-select";
import FormInputSpin from "pages/components/forms/input-spin";
import FormClipboard from "pages/components/forms/clipboard";
import EditorClassic from "pages/components/forms/editor/editor-classic";
import BasicTable from "pages/components/table/basic";
import ReactDataTable from "pages/components/table/react-table";
import RemixIcon from "pages/components/icons/remix";
import LucidIcon from "pages/components/icons/lucide";
import MapsGoogle from "pages/components/maps-google";
import MapsLeaflet from "pages/components/maps-leaflet";

//Charts
import AreaCharts from "pages/apex-charts/area-charts/index";
import BarCharts from "pages/apex-charts/bar-charts";
import BoxplotCharts from "pages/apex-charts/boxplot-charts";
import BubbleCharts from "pages/apex-charts/bubble-charts";
import CandlstickCharts from "pages/apex-charts/candlstick-charts";
import ColumnCharts from "pages/apex-charts/column-charts";
import FunnelCharts from "pages/apex-charts/funnel-charts";
import HeatmapChart from "pages/apex-charts/heatmap-chart";
import LineChart from "pages/apex-charts/line-charts";
import MixedChart from "pages/apex-charts/mixed-charts/Index";
import PieChart from "pages/apex-charts/pie-charts/Index";
import PolarAreaChart from "pages/apex-charts/polar-area-charts/Index";
import RadarChart from "pages/apex-charts/radar-charts/Index";
import RadialbarChart from "pages/apex-charts/radial-bar-charts/Index";
import RangeAreaChart from "pages/apex-charts/range-area-charts";
import Scatterchart from "pages/apex-charts/scatter-charts/Index";
import TimeLinechart from "pages/apex-charts/timeline-charts/Index";
import Treemapchart from "pages/apex-charts/tree-map-charts/Index";

// Landing
import OnePage from "pages/components/landing/onepage";
import Product from "pages/components/landing/product";

// auth
import Basic from "pages/authentication-inner/login/basic";
import LoginCover from "pages/authentication-inner/login/login-cover";
import LoginBoxed from "pages/authentication-inner/login/login-boxed";
import LoginModern from "pages/authentication-inner/login/login-modern";

//Register
import BasicRegister from "pages/authentication-inner/register/basic";
import RegisterCover from "pages/authentication-inner/register/register-cover";
import RegisterBoxed from "pages/authentication-inner/register/register-boxed";
import RegisterModern from "pages/authentication-inner/register/register-modern";

// EmailVerify
import BasicEmailVerify from "pages/authentication-inner/verify-email/basic";
import EmailCover from "pages/authentication-inner/verify-email/email-cover";
import EmailModern from "pages/authentication-inner/verify-email/email-modern";

// TwoSteps
import BasicTwoSteps from "pages/authentication-inner/two-steps/basic";
import TwoStepsCover from "pages/authentication-inner/two-steps/two-steps-cover";
import TwoStepsBoxed from "pages/authentication-inner/two-steps/two-steps-boxed";
import TwoStepsModern from "pages/authentication-inner/two-steps/two-steps-modern";

// Logout
import BasicLogout from "pages/authentication-inner/logout/basic";
import LogoutCover from "pages/authentication-inner/logout/logout-cover";
import LogoutBoxed from "pages/authentication-inner/logout/logout-boxed";
import LogoutModern from "pages/authentication-inner/logout/logout-modern";

// Reset Password
import BasicResetPassword from "pages/authentication-inner/reset-password/basic";
import ResetPasswordCover from "pages/authentication-inner/reset-password/reset-password-cover";
import ResetPasswordBoxed from "pages/authentication-inner/reset-password/reset-password-boxed";
import ResetPasswordModern from "pages/authentication-inner/reset-password/reset-password-modern";

// Create Password
import BasicCreatePassword from "pages/authentication-inner/create-password/Basic";
import CreatePasswordModern from "pages/authentication-inner/create-password/CreatePasswordModern";
import CreatePasswordCover from "pages/authentication-inner/create-password/CreatePasswordCover";
import CreatePasswordBoxed from "pages/authentication-inner/create-password/CreatePasswordBoxed";

import ComingSoon from "pages/common/coming-soon";
import Pages404 from "pages/common/pages-404";
import Offline from "pages/common/offline";
import Maintenance from "pages/common/maintenance";
import Settings from "pages/pages/settings";
import Pricing from "pages/pages/pricing";
import Faqs from "pages/pages/Faqs";
import ContactUs from "pages/pages/contact-us";

interface RouteObject {
  path: string;
  component: React.ComponentType<any>; // Use React.ComponentType to specify the type of the component
  exact?: boolean;
}


//Admin Portal
const adminPublicRoutes: Array<RouteObject> = [
  //Login
  { path: RoutePath.Admin_Login_page, component: AdminLoginPage },
  { path: RoutePath.Admin_Login_OTP, component: AdminOTPPage },
  { path: RoutePath.Admin_Login_Logout, component: AdminLogout },
  { path: RoutePath.Admin_ForgetPassword, component: AdminForgetPasswordPage },
  { path: RoutePath.Admin_ResetPassword, component: AdminResetPasswordPage }
]
const adminProtectedRoutes: Array<RouteObject> = [
  { path: "/", component: AdminDashboard },
  { path: RoutePath.Admin_Dashborad_page, component: AdminDashboard },
  { path: RoutePath.Admin_Profile, component: AdminUserProfile },

  { path: RoutePath.Admin_TenantList, component: TenantSearchPage },
  { path: RoutePath.Admin_TenantOnboard, component: TenantOnboardPage },
  { path: RoutePath.Admin_TenantEdit, component: TenantEditPage },

  { path: RoutePath.Admin_ServiceTypes, component: ServiceTypePage },
  { path: RoutePath.Admin_Services, component: ServicesPage },
  { path: RoutePath.Admin_VehicleModels, component: VehicleModelImportPage },

  { path: RoutePath.Admin_Subscriptions, component: SubscriptionPage },
  { path: RoutePath.Admin_Subscription_new, component: SubscriptionManagePage },
  { path: RoutePath.Admin_Subscription_manage, component: SubscriptionManagePage },
]


//Sample Project
const authProtectedRoutes: Array<RouteObject> = [
  // Dashboard
  /* { path: "/", component: Ecommerce }, */
  { path: RoutePath.Dashborad_page, component: Ecommerce },
  { path: "/dashboards-analytics", component: Analytics },
  { path: "/dashboards-email", component: Email },
  { path: "/dashboards-hr", component: HRDashboard },
  { path: "/dashboards-social", component: SocialMediaDashboard },

  // profile
  { path: RoutePath.User_profile, component: UserProfile },


  // Ui Element
  { path: "/ui-alerts", component: UiAlert },
  { path: "/ui-avatar", component: UiAvatar },
  { path: "/ui-buttons", component: UiButtons },
  { path: "/ui-label", component: UiLabel },
  { path: "/ui-cards", component: UiCards },
  { path: "/ui-collapse", component: UiCollapse },
  { path: "/ui-countdown", component: UiCountdown },
  { path: "/ui-drawer", component: UIDrawer },
  { path: "/ui-dropdown", component: UiDropdown },
  { path: "/ui-gallery", component: UiGallery },
  { path: "/ui-lists", component: UiLists },
  { path: "/ui-notification", component: UiNotification },
  { path: "/ui-modal", component: UiModal },
  { path: "/ui-spinners", component: UiSpinners },
  { path: "/ui-timeline", component: UITimeline },
  { path: "/ui-progress-bar", component: UiProgressBar },
  { path: "/ui-tooltip", component: UITooltip },
  { path: "/ui-video", component: UiVideo },

  // plugins
  { path: "/plugins-simplebar", component: PSimpleBar },
  { path: "/plugins-lightbox", component: PLightBox },
  { path: "/plugins-swiper-slider", component: SwiperSlider },
  { path: "/plugins-scroll-hint", component: ScrollHint },
  { path: "/plugins-video-player", component: VideoPlayer },

  // navigation
  { path: "/navigation-navbars", component: NavBars },
  { path: "/navigation-tabs", component: NavTabs },
  { path: "/navigation-breadcrumb", component: NavigationBreadcrumb },
  { path: "/navigation-pagination", component: Pagination },

  // Forms
  { path: "/forms-basic", component: FormsBasic },
  { path: "/forms-validation", component: FormValidation },
  { path: "/forms-input-mask", component: InputMask },
  { path: "/forms-select", component: FormSelect },
  { path: "/forms-checkbox-radio", component: CheckboxRadio },
  { path: "/forms-switches", component: FormSwitches },
  { path: "/forms-wizard", component: FormWizard },
  { path: "/forms-file-upload", component: FileUpload },
  { path: "/forms-datepicker", component: FormDatePicker },
  { path: "/forms-timepicker", component: FormTimePicker },
  { path: "/forms-colorpicker", component: FormColorPicker },
  { path: "/forms-multi-select", component: FormMultiSelect },
  { path: "/forms-input-spin", component: FormInputSpin },
  { path: "/forms-clipboard", component: FormClipboard },
  { path: "/forms-editor-classic", component: EditorClassic },

  // Table
  { path: "/tables-basic", component: BasicTable },
  { path: "/tables-datatable", component: ReactDataTable },

  // Icons
  { path: "/icons-remix", component: RemixIcon },
  { path: "/icons-lucide", component: LucidIcon },

  // Map
  // { path: "/maps-google", component: MapsGoogle },
  { path: "/maps-leaflet", component: MapsLeaflet },


  //Charts
  { path: "/charts-apex-area", component: AreaCharts },
  { path: "/charts-apex-bar", component: BarCharts },
  { path: "/charts-apex-boxplot", component: BoxplotCharts },
  { path: "/charts-apex-bubble", component: BubbleCharts },
  { path: "/charts-apex-candlstick", component: CandlstickCharts },
  { path: "/charts-apex-column", component: ColumnCharts },
  { path: "/charts-apex-funnel", component: FunnelCharts },
  { path: "/charts-apex-heatmap", component: HeatmapChart },
  { path: "/charts-apex-line", component: LineChart },
  { path: "/charts-apex-mixed", component: MixedChart },
  { path: "/charts-apex-pie", component: PieChart },
  { path: "/charts-apex-polar", component: PolarAreaChart },
  { path: "/charts-apex-radar", component: RadarChart },
  { path: "/charts-apex-radialbar", component: RadialbarChart },
  { path: "/charts-apex-range-area", component: RangeAreaChart },
  { path: "/charts-apex-scatter", component: Scatterchart },
  { path: "/charts-apex-timeline", component: TimeLinechart },
  { path: "/charts-apex-treemap", component: Treemapchart },

  // Chat
  { path: "/apps-chat", component: Chat },

  // Mailbox
  { path: "/apps-mailbox", component: Mailbox },

  // Calendar
  { path: "/apps-calendar", component: DefaultCalendar },
  { path: "/apps-calendar-month-grid", component: MonthGrid },
  { path: "/apps-calendar-multi-month-stack", component: MultiMonthStack },

  // Ecommerce
  { path: "/apps-ecommerce-product-list", component: ListView },
  { path: "/apps-ecommerce-product-grid", component: GridView },
  { path: "/apps-ecommerce-product-overview", component: Overview },
  { path: "/apps-ecommerce-product-create", component: AddNew },
  { path: "/apps-ecommerce-cart", component: ShoppingCart },
  { path: "/apps-ecommerce-checkout", component: Checkout },
  { path: "/apps-ecommerce-orders", component: Orders },
  { path: "/apps-ecommerce-order-overview", component: OrderOverview },
  { path: "/apps-ecommerce-sellers", component: Sellers },

  // HR Management
  { path: "/apps-hr-employee", component: EmployeeList },
  { path: "/apps-hr-holidays", component: Holidays },
  { path: "/apps-hr-leave-employee", component: LeaveManageEmployee },
  { path: "/apps-hr-create-leave-employee", component: AddLeaveEmployee },
  { path: "/apps-hr-leave", component: LeaveManageHR },
  { path: "/apps-hr-create-leave", component: AddLeaveHR },
  { path: "/apps-hr-attendance", component: AttendanceHR },
  { path: "/apps-hr-attendance-main", component: MainAttendance },
  { path: "/apps-hr-department", component: Departments },
  { path: "/apps-hr-sales-estimates", component: Estimates },
  { path: "/apps-hr-sales-payments", component: Payments },
  { path: "/apps-hr-sales-expenses", component: Expenses },
  { path: "/apps-hr-payroll-employee-salary", component: EmployeeSalary },
  { path: "/apps-hr-payroll-payslip", component: Payslip },
  { path: "/apps-hr-payroll-create-payslip", component: CreatePayslip },

  // Notes
  { path: "/apps-notes", component: Notes },

  // Social Media
  { path: "/apps-social-friends", component: Friends },
  { path: "/apps-social-event", component: Event },
  { path: "/apps-social-video", component: WatchVideo },
  { path: "/apps-social-marketplace", component: Marketplace },

  // Invoices
  { path: "/apps-invoice-list", component: InvoiceListView },
  { path: "/apps-invoice-add-new", component: InvoiceAddNew },
  { path: "/apps-invoice-overview", component: InvoiceOverview },

  // Users
  { path: "/apps-users-list", component: UserListView },
  { path: "/apps-users-grid", component: UserGridView },

  // pages
  { path: "/pages-account", component: Account },
  { path: "/pages-account-settings", component: Settings },
  { path: "/pages-pricing", component: Pricing },
  { path: "/pages-faqs", component: Faqs },
  { path: "/pages-contact-us", component: ContactUs },


];

const publicRoutes = [

  // authentication
  { path: RoutePath.Login_page, component: Login },
  { path: RoutePath.Login_OTP, component: OTPScreen },
  { path: "/logout", component: Logout },
  { path: "/register", component: Register },


  // Landing
  { path: "/onepage-landing", component: OnePage },
  { path: "/product-landing", component: Product },

  // auth
  { path: "/auth-login-basic", component: Basic },
  { path: "/auth-login-cover", component: LoginCover },
  { path: "/auth-login-boxed", component: LoginBoxed },
  { path: "/auth-login-modern", component: LoginModern },

  // Register
  { path: "/auth-register-basic", component: BasicRegister },
  { path: "/auth-register-cover", component: RegisterCover },
  { path: "/auth-register-boxed", component: RegisterBoxed },
  { path: "/auth-register-modern", component: RegisterModern },

  // Verify Email
  { path: "/auth-verify-email-basic", component: BasicEmailVerify },
  { path: "/auth-verify-email-cover", component: EmailCover },
  { path: "/auth-verify-email-modern", component: EmailModern },

  // two steps
  { path: "/auth-two-steps-basic", component: BasicTwoSteps },
  { path: "/auth-two-steps-cover", component: TwoStepsCover },
  { path: "/auth-two-steps-boxed", component: TwoStepsBoxed },
  { path: "/auth-two-steps-modern", component: TwoStepsModern },

  // logout
  { path: "/auth-logout-basic", component: BasicLogout },
  { path: "/auth-logout-cover", component: LogoutCover },
  { path: "/auth-logout-boxed", component: LogoutBoxed },
  { path: "/auth-logout-modern", component: LogoutModern },

  //Reset Password
  { path: "/auth-reset-password-basic", component: BasicResetPassword },
  { path: "/auth-reset-password-cover", component: ResetPasswordCover },
  { path: "/auth-reset-password-boxed", component: ResetPasswordBoxed },
  { path: "/auth-reset-password-modern", component: ResetPasswordModern },

  //Create Password
  { path: "/auth-create-password-basic", component: BasicCreatePassword },
  { path: "/auth-create-password-cover", component: CreatePasswordCover },
  { path: "/auth-create-password-boxed", component: CreatePasswordBoxed },
  { path: "/auth-create-password-modern", component: CreatePasswordModern },

  // coming soon
  { path: "/pages-coming-soon", component: ComingSoon },

  // Error
  { path: "/pages-offline", component: Offline },
  { path: "/pages-404", component: Pages404 },

  // Maintenance
  { path: "/pages-maintenance", component: Maintenance },




]


export {
  adminPublicRoutes, adminProtectedRoutes,
  authProtectedRoutes, publicRoutes
};
